import { getFileName } from '@/utils/files'
import mediaService from '@/services/media.service'
import { showAlertError } from '@/utils/store/alert'

export const mixinFile = {
  props: {
    file: {
      type: [File, Object],
      required: true
    },
    cacheFile: {
      type: Boolean,
      default: true
    },
    fileAutoLoad: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      media: null,
      isLoadingFile: false
    }
  },

  beforeDestroy () {
    if (this.cacheFile) {
      return
    }

    mediaService.revoke(this.file)
  },

  computed: {
    fileName () {
      return getFileName(this.file)
    },
    fileURL () {
      return this.media?.objectUrl || ''
    },

    fileBlob () {
      return this.media?.blob || null
    }
  },

  methods: {
    async ensureLoaded () {
      try {
        this.isLoadingFile = true
        this.media = null
        this.media = await mediaService.load(this.file)
      } catch (e) {
        showAlertError(e)
      } finally {
        this.isLoadingFile = false
      }
    }
  },
  watch: {
    file: {
      async handler () {
        if (this.fileAutoLoad) {
          await this.ensureLoaded()
        }
      }
    }
  }
}
